import React from 'react';
import { Link } from 'react-router-dom';
import { SignedIn, SignedOut, SignInButton, UserButton } from '@clerk/clerk-react';
import Typography from '../atoms/Typography';
import Button from '../atoms/Button';
import FloatingModelsContainer from '../organisms/FloatingModelsContainer';
import './LandingTemplate.css';

const LandingTemplate = ({ onStartClick }) => {
  // Check if Clerk is available
  const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
  
  // Development mode without Clerk
  if (!clerkPubKey) {
    return (
      <div className="landing-template">
        <FloatingModelsContainer />
        
        <div className="landing-content glass-card">
          <div className="landing-header">
            <div className="chinese-icon">汉语</div>
            <Typography variant="h1" color="white" align="center" className="heading-xl landing-title">
              Super Mandarin Conversation
            </Typography>
            <Typography variant="subtitle1" color="dark" align="center" className="landing-subtitle">
              Practice Mandarin with our AI-powered conversation partner
            </Typography>
          </div>
          
          <div className="landing-actions">
            <Button 
              onClick={onStartClick} 
              variant="primary" 
              size="large"
              className="btn btn-primary landing-cta"
            >
              开始对话 - Start Conversation
            </Button>
            
            <Link to="/models" className="models-link">
              <Button variant="secondary" size="medium" className="models-button">
                View 3D Character Models
              </Button>
            </Link>
            
            <Typography variant="body2" color="dark" align="center" className="auth-message">
              ⚠️ Development mode - No authentication required
            </Typography>
          </div>
        </div>
        
        {/* Overlapping Fun Message Cards */}
        <div className="floating-messages">
          <div className="fun-card fun-card-1">
            <div className="fun-card-glow"></div>
            <div className="fun-card-content">
              <span className="fun-text">🎤 Press the mic and speak, or type to practice</span>
            </div>
          </div>
          <div className="fun-card fun-card-2">
            <div className="fun-card-glow"></div>
            <div className="fun-card-content">
              <span className="fun-text">🤔 If your pronunciation is off, the bot will reply as a native misunderstanding you</span>
            </div>
          </div>
          <div className="fun-card fun-card-3">
            <div className="fun-card-glow"></div>
            <div className="fun-card-content">
              <span className="fun-text">💪 try and try again, make yourself understood</span>
            </div>
          </div>
          <div className="fun-card fun-card-4">
            <div className="fun-card-glow"></div>
            <div className="fun-card-content">
              <span className="fun-text">🎉 or just have fun and talk of any topic</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Production mode with Clerk
  return (
    <div className="landing-template">
      <FloatingModelsContainer />
      
      <div className="landing-content glass-card">
        <div className="landing-header">
          <div className="chinese-icon">汉语</div>
          <Typography variant="h1" color="white" align="center" className="heading-xl landing-title">
            Super Mandarin Conversation
          </Typography>
          <Typography variant="subtitle1" color="dark" align="center" className="landing-subtitle">
            Practice Mandarin with our AI-powered conversation partner
          </Typography>
        </div>
        
        <div className="landing-actions">
          <SignedIn>
            <Button 
              onClick={onStartClick} 
              variant="primary" 
              size="large"
              className="btn btn-primary landing-cta"
            >
              开始对话 - Start Conversation
            </Button>
            
            <Link to="/models" className="models-link">
              <Button variant="secondary" size="medium" className="models-button">
                View 3D Character Models
              </Button>
            </Link>
            
            <div className="user-profile">
              <UserButton afterSignOutUrl="/" />
            </div>
          </SignedIn>
          
          <SignedOut>
            <SignInButton mode="modal">
              <Button 
                variant="primary" 
                size="large"
                className="btn btn-primary landing-cta"
              >
                Sign In to Start Learning
              </Button>
            </SignInButton>
            
            <Typography variant="body2" color="dark" align="center" className="auth-message">
              Please sign in to access the conversation features
            </Typography>
          </SignedOut>
        </div>
      </div>
      
      {/* Overlapping Fun Message Cards */}
      <div className="floating-messages">
        <div className="fun-card fun-card-1">
          <div className="fun-card-glow"></div>
          <div className="fun-card-content">
            <span className="fun-text">🎤 Press the mic and speak, or type to practice</span>
          </div>
        </div>
        <div className="fun-card fun-card-2">
          <div className="fun-card-glow"></div>
          <div className="fun-card-content">
            <span className="fun-text">🤔 If your pronunciation is off, the bot will reply as a native misunderstanding you</span>
          </div>
        </div>
        <div className="fun-card fun-card-3">
          <div className="fun-card-glow"></div>
          <div className="fun-card-content">
            <span className="fun-text">💪 try and try again, make yourself understood</span>
          </div>
        </div>
        <div className="fun-card fun-card-4">
          <div className="fun-card-glow"></div>
          <div className="fun-card-content">
            <span className="fun-text">🎉 or just have fun and talk of any topic</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingTemplate; 